import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _CloseIcon;
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
/* eslint-disable max-lines */
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import { delay, setDigitalData } from '../utils';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { styled, useTheme } from '@mui/material/styles';
import { useTranslate } from '@im/react-localization';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchTextField(props) {
  var PopperComponent = props.PopperComponent,
    autoFocus = props.autoFocus,
    testid = props['data-testid'],
    _props$enableAISugges = props.enableAISuggestions,
    enableAISuggestions = _props$enableAISugges === void 0 ? false : _props$enableAISugges,
    getSearchSuggestions = props.getSearchSuggestions,
    onSearch = props.onSearch,
    placeholder = props.placeholder,
    sx = props.sx;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 1),
    selectedCategories = _useState2[0];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    term = _useState4[0],
    setTerm = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    suggestions = _useState6[0],
    setSuggestions = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    inputValue = _useState8[0],
    setInputValue = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    mouseInListBox = _useState0[0],
    setMouseInListBox = _useState0[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var location = useLocation();
  var translate = useTranslate();
  var theme = useTheme();
  var onChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event, value) {
      var queryParam, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof value === 'string')) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            queryParam = 'keywords';
            _context.t0 = value.type;
            _context.next = _context.t0 === 'Products' ? 6 : _context.t0 === 'Vendors' ? 8 : _context.t0 === 'Categories' ? 10 : _context.t0 === 'SubCategories' ? 12 : 14;
            break;
          case 6:
            queryParam = 'keywords';
            return _context.abrupt("break", 14);
          case 8:
            queryParam = 'vendor';
            return _context.abrupt("break", 14);
          case 10:
            queryParam = 'category';
            return _context.abrupt("break", 14);
          case 12:
            queryParam = 'subcategory';
            return _context.abrupt("break", 14);
          case 14:
            setInputValue(value.option);
            _context.next = 17;
            return onSearch({
              searchType: queryParam,
              selectedCategories: selectedCategories,
              text: value.option
            });
          case 17:
            res = _context.sent;
            if (res) {
              setDigiData('keyword suggestion', value.option, queryParam);
            }
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onChange(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var onInputChange = function onInputChange(event, text, reason) {
    if (reason === 'input') {
      setInputValue(text);
      setTerm(text.trimStart());
    }
  };
  var onKeyPress = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      var res;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(event.key === 'Enter')) {
              _context2.next = 7;
              break;
            }
            if (!term) {
              _context2.next = 6;
              break;
            }
            _context2.next = 4;
            return onSearch({
              searchType: 'keywords',
              selectedCategories: selectedCategories,
              text: term
            });
          case 4:
            res = _context2.sent;
            if (res) {
              setDigiData('Enter', term, 'keyword');
            }
          case 6:
            event.preventDefault();
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onKeyPress(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSearch = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(triggeredBy) {
      var res;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!term) {
              _context3.next = 5;
              break;
            }
            _context3.next = 3;
            return onSearch({
              searchType: 'keywords',
              selectedCategories: selectedCategories,
              text: term
            });
          case 3:
            res = _context3.sent;
            if (res) {
              setDigiData(triggeredBy, term, 'keyword');
            }
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleSearch(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var onClose = function onClose() {
    setInputValue('');
    setTerm('');
  };
  var setDigiData = function setDigiData(submit, term, type) {
    setTimeout(function () {
      setDigitalData({
        internalSearch: {
          searchReferrerPage: location == null ? void 0 : location.pathname,
          searchSubmit: submit,
          searchTerm: term,
          searchType: type
        }
      });
    }, 2000);
  };
  useEffect(function () {
    var _searchParams$get, _searchParams$get2, _searchParams$get3;
    var keywords = (_searchParams$get = searchParams.get('keywords')) != null ? _searchParams$get : '';
    var title = (_searchParams$get2 = searchParams.get('title')) != null ? _searchParams$get2 : '';
    var displaytitle = (_searchParams$get3 = searchParams.get('displaytitle')) != null ? _searchParams$get3 : '';
    if (location.pathname === '/product/productsearch' || location.pathname === '/product/associateproductsearch') {
      var inpVal = title && title !== '' ? '' : displaytitle || '';
      setInputValue(inpVal);
      setTerm(inpVal);
    } else if (keywords !== '') {
      setInputValue(keywords);
    } else {
      setInputValue('');
      setTerm('');
    }
  }, [location.pathname, searchParams]);
  useEffect(function () {
    var active = true;
    if (!term) {
      setSuggestions([]);
    } else {
      _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var response, reformatedSuggestions;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return delay(300);
            case 2:
              if (active) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return");
            case 4:
              _context4.next = 6;
              return getSearchSuggestions(term);
            case 6:
              response = _context4.sent;
              if (active) {
                reformatedSuggestions = response.reduce(function (accu, row) {
                  var suggestionRows = [];
                  // eslint-disable-next-line array-callback-return
                  row.suggestions.map(function (suggestion) {
                    if (typeof suggestion === 'string') {
                      return suggestionRows.push({
                        option: suggestion,
                        type: row.category
                      });
                    }
                  });
                  accu = accu.concat(suggestionRows);
                  return accu;
                }, []);
                setSuggestions(reformatedSuggestions);
              }
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
    // Note: cleanup function runs before the effect is re-executed.
    return function () {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [term]);

  //to be removed when im-theme is in place
  var listBoxProps = {
    onMouseEnter: function onMouseEnter() {
      return setMouseInListBox(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setMouseInListBox(false);
    },
    sx: {
      '& .MuiAutocomplete-groupLabel': {
        backgroundColor: '#F8F8F8',
        // this value is not present in im-theme
        borderBottom: 1,
        borderBottomColor: '#E0E0E0',
        // this value is not present in im-theme
        display: enableAISuggestions ? 'none' : 'block'
      },
      '& .MuiAutocomplete-groupUl': {
        '&::-webkit-scrollbar': {
          width: '10px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundClip: 'padding-box',
          backgroundColor: '#bdbdbd',
          // this value is not present in im-theme
          border: '4px solid rgba(0, 0, 0, 0)'
        },
        maxHeight: '144px',
        overflowX: 'hidden',
        overflowY: 'overlay'
      },
      '& .MuiAutocomplete-groupUl .MuiAutocomplete-option': {
        paddingLeft: '16px'
      },
      '& .MuiAutocomplete-option.Mui-focused': {
        backgroundColor: !mouseInListBox ? "".concat(theme.palette.common.white) : 'rgba(0, 119, 212, 0.15) !important'
      },
      '& .link-selector-description ol, ul': {
        display: 'block !important'
      },
      'li:first-child': {
        '& .MuiAutocomplete-groupUl': {
          maxHeight: enableAISuggestions ? '500px' : '288px'
        }
      },
      maxHeight: '620px',
      p: 0
    }
  };
  return /*#__PURE__*/_jsx(StyledAutocomplete, {
    ListboxProps: listBoxProps,
    PopperComponent: PopperComponent,
    disableClearable: true,
    filterOptions: function filterOptions(options) {
      return options;
    },
    freeSolo: true,
    fullWidth: true,
    getOptionLabel: function getOptionLabel(option) {
      return typeof option === 'string' ? option : option.option;
    },
    groupBy: function groupBy(option) {
      return option.type;
    },
    inputValue: inputValue,
    onChange: onChange,
    onInputChange: onInputChange,
    onKeyDownCapture: function onKeyDownCapture(e) {
      if (e.key === 'Enter' && !mouseInListBox) {
        e.stopPropagation();
        e.target.blur();
        handleSearch('Enter');
      }
    },
    options: suggestions,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_jsx(TextField
      // eslint-disable-next-line jsx-a11y/no-autofocus
      , _extends({
        autoFocus: autoFocus,
        className: "searchText",
        "data-testid": "".concat(testid, "-SearchText")
      }, params, {
        InputProps: _extends({}, params.InputProps, {
          endAdornment: /*#__PURE__*/_jsx(IconButton, {
            "aria-label": translate('Dashboard.Delete'),
            "data-name": "search_delete",
            onClick: onClose,
            sx: {
              marginRight: '8px',
              padding: 0,
              visibility: inputValue ? 'visible' : 'hidden'
            },
            children: _CloseIcon || (_CloseIcon = /*#__PURE__*/_jsx(CloseIcon, {}))
          }),
          startAdornment: /*#__PURE__*/_jsx(InputAdornment, {
            position: "start",
            children: /*#__PURE__*/_jsx(IconButton, {
              "aria-label": translate('Common.Search'),
              onClick: function onClick() {
                return handleSearch('searchIcon');
              },
              sx: {
                marginLeft: '4px',
                marginRight: '8px',
                padding: 0
              },
              children: /*#__PURE__*/_jsx(SearchIcon, {
                "data-testid": "".concat(testid, "-SearchIcon")
              })
            })
          })
        }),
        onKeyPress: onKeyPress,
        placeholder: placeholder != null ? placeholder : translate('Product.Searchplaceholder')
      }));
    },
    renderOption: function renderOption(props, option, _ref5) {
      var inputValue = _ref5.inputValue;
      var matches = match(option.option, inputValue, {
        insideWords: true
      });
      var parts = parse(option.option, matches);
      return /*#__PURE__*/_jsx("li", _extends({}, props, {
        children: /*#__PURE__*/_jsx("div", {
          children: parts.map(function (part, index) {
            return /*#__PURE__*/_jsx("span", {
              style: {
                fontWeight: part.highlight ? 400 : 'bold'
              },
              children: part.text
            }, index);
          })
        })
      }));
    },
    selectOnFocus: true,
    sx: sx,
    "data-element": "StyledAutocomplete",
    "data-component": "SearchTextField",
    "data-source-file": "SearchTextField.tsx"
  });
}
var StyledAutocomplete = styled(Autocomplete)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    '& .MuiDivider-root': {
      alignSelf: 'center',
      height: 24
    },
    '& .MuiSvgIcon-root': {
      fontSize: '24px'
    },
    '& .MuiTextField-root .MuiInputAdornment-root': {
      '& .MuiSvgIcon-root': {
        height: '24px',
        width: '24px'
      },
      margin: 0
    },
    '& .micIcon': {
      padding: '8.5px 7px'
    },
    '& .searchText': {
      '& .MuiOutlinedInput-input': {
        color: theme.palette.grey[600],
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px',
        padding: 0
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: '4px',
        flexWrap: 'nowrap',
        height: '32px',
        marginTop: 0
      }
    },
    '& .uploadImg': {
      paddingBottom: 8.5,
      paddingLeft: 4,
      paddingRight: 7,
      paddingTop: 8.5
    },
    height: '32px',
    width: '100%'
  };
});